export default "__VITE_ASSET__CcYmAFap__"